import React from 'react';
import { BsPersonCircle } from 'react-icons/bs';
import Button from 'components/Button';
import { Tutor } from 'global/types';

import './index.css';

type MyTutorsProps = {
    tutors: Tutor[];
    setTabIndex: (index: number) => void;
};

function MyTutors({ tutors, setTabIndex }: MyTutorsProps) {
    return (
        <div className='myTutors'>
            {tutors.map(tutor => (
                <div className='myTutors__tutor'>
                    {tutor.profilePhoto
                        ? <img className='myTutors__photo' src={tutor.profilePhoto} />
                        : <BsPersonCircle className='myTutors__avatar' />
                    }
                    <div className='myTutors__info'>
                        <h4 className='myTutors__name'>
                            {tutor.firstName} {tutor.lastName}
                        </h4>
                        <p className='myTutors__description'>
                            Connected on {new Date(tutor.connectedOn).toLocaleDateString()}
                        </p>
                    </div>
                    <Button className='myTutors__button' onClick={() => setTabIndex(1)}>
                        Assignments
                    </Button>
                </div>    
            ))}
        </div>
    );
}

export default MyTutors;